import { pathOr } from 'ramda';

import { IState } from 'shared/store';

export const selectTourV2BannerImageUrlV2 = (state: IState): string | null =>
  // Для превью берем это
  pathOr(null, ['offerData', 'tourV2', 'tourBannerImageUrl'], state);
